<template>
  <div class="history">
    <inline-loader :loading="loading" v-if="loading && !nodata" />
    <div class="ms-nodata ms-text" v-else-if="!loading && nodata">
      Не удалось загрузить список последних действий. Повторите, пожалуйста,
      попытку позже
    </div>
    <template v-else-if="actions.length">
      <div class="history-filters">
        <i-select
          v-model="filter"
          size="small"
          :transfer="false"
        >
          <i-option v-for="item in filters" :value="item.id" :key="item.id">
            {{ item.name }}
          </i-option>
        </i-select>
      </div>
      <div class="history-container">
        <history-list :actions="filteredActions" v-if="filteredActions.length" />
        <div class="ms-nodata ms-help" v-else>
          Последние действия по выбранному типу объектов отсутствуют
        </div>
      </div>
    </template>
    <div class="ms-nodata ms-help" v-else>
      Последние действия по проекту отсутствует
    </div>
  </div>
</template>

<script>
import InlineLoader from '@/components/loaders/inline-loader'
import HistoryList from './history-list'

const filters = [
  { id: 'all', name: 'Все' },
  { id: 'contracts', name: 'Проект' },
  { id: 'amendments', name: 'ДС' },
  { id: 'contragents', name: 'Подрядчики' },
  { id: 'acts', name: 'Акты' },
  { id: 'payments', name: 'Платежи' },
  { id: 'law_cases', name: 'Судебные дела' },
  { id: 'resources', name: 'Материалы' }
]

export default {
  components: {
    InlineLoader,
    HistoryList
  },
  data () {
    return {
      actions: [],
      loading: false,
      nodata: false,
      filter: 'all',
      filters
    }
  },
  computed: {
    filteredActions () {
      if (this.filter === 'all') return this.actions

      return this.actions.filter(a => a.table_name === this.filter)
    }
  },
  methods: {
    async getData () {
      const { id } = this.$route.params

      try {
        this.loading = true
        const url = `page/last_action?contract_id=${id}`
        this.actions = await this.$store.dispatch('GET_REQUEST', { url })
        this.loading = false
      } catch (error) {

      }
    }
  },
  created () {
    this.getData()
  }
}
</script>

<style lang="less">
.history {
  &-filters {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 16px;

    .ivu-select {
      width: 50%;
    }
  }
}
</style>
